import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { destroyPost, toggleShow } from "src/actions/community/postsActions";
import { useNavigate, useSearchParams } from "react-router-dom";
import { doHighlight } from "src/helpers/TextHelpers";

import {ButtonDestroy, ButtonEdit, ButtonToggleShow} from "src/componets/Buttons";
import { setEditId, PostInterface } from "src/store/community/postsSlice";
import { ColumnsType } from "antd/es/table";
import { message, Space, Typography } from "antd";

import Table from "src/componets/Table";
import Meta from "./_Meta";

const { Paragraph } = Typography;

interface ListTableInterface {
  className?: string;
}

const _ListTable = ({ className }: ListTableInterface) => {
  const navigate        = useNavigate();
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const term            = searchParams.get('term') || '';
  const ids             = useAppSelector(state => state.community.posts.ids);
  const posts    = useAppSelector(state => state.community.posts.entities);
  const data            = ids ? ids.map(id => posts[id]) : [];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  function onToggleShow(id: any, published: boolean) {
    dispatch(toggleShow({ id, published: published }));
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyPost(id));

    if (destroyPost.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyPost.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const columns: ColumnsType<PostInterface> = [
    {
      key: 'post',
      title: 'Post',
      render: (_, post) => {
        return <Meta post={post} size='medium' showStats={true} />;
      },
      width: 185,
      ellipsis: true
    },

    {
      key: 'search_text',
      title: 'Search text & Tags',
      render: (_, { search_text }) => {
        return (
          <div>
            <Paragraph ellipsis={{ rows: 2, expandable: true }}>
              {doHighlight(search_text, term)}
            </Paragraph>
          </div>
        );
      },
      width: 250
    },

    {
      key: 'action',
      title: 'Action',
      render: (_, { id, published }) => {
        return (
          <Space size="middle">
            <ButtonToggleShow
              key={'toggle-show'}
              onClick={() => onToggleShow(id, published)}
              state={published}
            />
            <ButtonEdit key={'button-edit'} onClick={() => onClickEdit(id)} />
            <ButtonDestroy key='button-destroy' onClick={() => onClickDestroy(id)} />
          </Space>
        );
      },
      width: 150
    },
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />
    </div>
  )
}

export default _ListTable;
